import { StyleSheet } from 'react-native';

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  containerStyle: {
    paddingVertical: 19,
    paddingLeft: 16,
    flexDirection: 'row',
    alignItems: 'center',
  },
  dividerStyle: theme => ({
    backgroundColor: theme.colors.divider,
    height: 1,
    marginHorizontal: 16,
  }),
  infoContainerStyle: {
    flex: 1,
    justifyContent: 'center',
    marginHorizontal: 16,
  },
  nameTextStyle: {
    fontSize: 16,
    lineHeight: 25,
  },
  subtitleTextStyle: {
    fontSize: 14.6,
    lineHeight: 18.7,
    color: Colors.light_grey,
  },
  removeContainerStyle: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingRight: 16,
  },
  removeTextStyle: {
    paddingTop: 2,
    fontSize: 14,
    marginRight: 9,
  },
  checkBoxStyle: {
    marginRight: 16,
  },
});
